/*global $, define, dna*/
define('core/factory/RedirectFactory',[
    'angular'
], function(angular) {
    'use strict';

    angular.module('dnaApp').factory('RedirectInterceptor', ['$q', '$location', '$rootScope', '$window', '$routeParams', '$log',
        function RedirectInterceptor($q, $location, $rootScope, $window, $routeParams, $log) {
            var processingPreviousRedirectError = false,
                    request = function(config) {
                        // The restTimeoutClient value == rest.timeout.read + rest.timeout.connect + 1 minute
                        if (!angular.isDefined(config.timeout)) {
                            config.timeout = dna.app.restTimeoutClient;
                        }
                        if (dna.app.basePath && config.url.indexOf("//") === -1 && config.url.indexOf(dna.app.basePath) !== 0) {
                            config.url = dna.app.basePath + config.url;
                        }
                        return config;
                    },
                    responseError = function (errorResponse) {
                        if (errorResponse) {

                            if (errorResponse.config && errorResponse.config.url) {

                                if (errorResponse.config.url.indexOf('/message') !== -1) {
                                    return $q.reject(errorResponse);
                                } else if (errorResponse.config.url.indexOf('/feedback') !== -1) {
                                    return $q.reject(errorResponse);
                                } else if (errorResponse.config.url.indexOf('graph.facebook.com') !== -1) {
                                    return $q.reject(errorResponse);
                                } else if (errorResponse.config.url.indexOf('/avro') !== -1) {
                                    return $q.reject(errorResponse);
                                }
                            }

                            if (processingPreviousRedirectError) {
                                return $q.reject(errorResponse);
                            }

                            if (errorResponse.status) {
                                // Redirect to the appropriate error page based on the response.
                                var redirect;
                                switch (errorResponse.status) {
                                    // UNAUTHORIZED
                                    case 401:
                                        // Redirect to the company standard login page.
                                        $rootScope.closeModal();

                                        processingPreviousRedirectError = true;
                                        $window.location.assign(dna.app.secureLoginUrl + encodeURIComponent($location.absUrl()));
                                        break;

                                    // FORBIDDEN
                                    case 403:
                                        if (errorResponse.data && errorResponse.data.ERROR && errorResponse.data.ERROR === 'SUBSCRIPTION') {
                                            $window.location.replace('/subscription');
                                        } else if ($location.path().indexOf('/evidence') !== -1) {
                                            redirect = '/insights/' + ($routeParams.testGuid || '');
                                        } else {
                                            redirect = '/403';
                                        }
                                        processingPreviousRedirectError = true;
                                        break;

                                    // NOT FOUND
                                    case 404:
                                        if (errorResponse.config.url.indexOf('/dna/origins/') === -1 && errorResponse.config.url.indexOf('/assets/i18n/') === -1) {
                                            $log.error('app 404', errorResponse.config.url);
                                        }
                                        break;

                                    //SERVER ON MAINTENANCE
                                    case 205:
                                        $window.location.reload();
                                        break;
                                    case 409: //ajax is incorrect, need logout/login
                                        $window.location.assign(dna.app.secureBaseUrl + "/logout?returnUrl="  + encodeURIComponent(dna.app.secureLoginUrl + encodeURIComponent($location.absUrl())));
                                }

                                if (redirect) {
                                    $rootScope.closeModal();
                                    $location.url(redirect).replace();
                                }
                            }
                        }

                        return $q.reject(errorResponse);
                    };

            return {
                request: request,
                responseError: responseError
            };
        }
    ]);
});
